import { FitpetMallEventEnum } from '@/constants/fitpet-mall-event.enum'
import { LocationEnum } from '@/constants/location.enum'
import { useTracker } from '../contexts/EventTrackingProvider'

type ViewBrandListProperty = {
  brandName: string
  location: LocationEnum
  selectedCategoryName?: string
  selectedSubCategoryName?: string
}

type ClickBrandListProperty = {
  brandName?: string
  selectedCategoryName?: string // ex) 용품
  selectedSubCategoryName?: string // ex) 칫솔/치약
  productId?: number
  productName?: string
  productPrice?: number
  productDiscountRate?: number
  productPurchasePrice?: number
  productReviewAvgscore?: number
  productReviewTotalCount?: number
}

const useBrandEventTracker = () => {
  const { triggerCustomEvent } = useTracker()

  /*
   * 브랜드 홈 진입시 호출
   * @link https://www.notion.so/industrious-ethernet-850/view_brand_list-498ef525d2f74a70b0cf57d1b83961be?pvs=4
   */
  const trackViewBrandListEvent = (p: ViewBrandListProperty) => {
    if (!p.brandName) return

    const properties = {
      brandName: p.brandName,
      location: p.location,
      depth_1: p.selectedCategoryName ?? 'empty',
      depth_2: p.selectedSubCategoryName ?? 'empty',
    }

    triggerCustomEvent(FitpetMallEventEnum.ViewBrandList, properties)
  }

  const trackClickBrandListEvent = (p: ClickBrandListProperty) => {
    if (!p.brandName) return

    // TODO: Event Tracker의 각 속성값을 변환해주는 util 함수가 필요함
    triggerCustomEvent(FitpetMallEventEnum.ClickBrandListProduct, {
      ...p,
      depth_1: p.selectedCategoryName ?? 'empty',
      depth_2: p.selectedSubCategoryName ?? 'empty',
      productPrice: Number(p.productPrice),
      productPurchasePrice: Number(p.productPurchasePrice),
      productDiscountRate: Math.floor((p.productDiscountRate ?? 0) * 100),
    })
  }

  return {
    trackViewBrandListEvent,
    trackClickBrandListEvent,
  }
}

export default useBrandEventTracker
